export default __webpack_public_path__ + "static/catholicIdea-9fba79c1a2549e829d9699bdf5387c06.svg";